import React from 'react';
import { connect } from 'react-redux';
import { selectIsWindowMode } from '@ff-os/pdp-shared-redux/slices/globalSlice';
import { Desktop } from '@ff-os/shared-react/components/breakpoints/Desktop';
import { Mobile } from '@ff-os/shared-react/components/breakpoints/Mobile';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { InlineGiftDesignerUi } from './display-inline/InlineGiftDesignerUi';
import { WindowGiftDesignerUi } from './display-window/WindowGiftDesignerUi';

const _GiftDesignerUi = ({ isWindowMode }: Props) => {

    if (isWindowMode) {
        return <WindowGiftDesignerUi />;
    }

    return (
        <>
            <Mobile>
                <WindowGiftDesignerUi />
            </Mobile>
            <Desktop>
                <InlineGiftDesignerUi />
            </Desktop>
        </>
    );
};

type Props = {
    isWindowMode: boolean;
};

const mapStateToProps = (state: GiftPdpState) => ({
    isWindowMode: selectIsWindowMode(state)
});

export const GiftDesignerUi = connect(mapStateToProps)(_GiftDesignerUi);